import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import { Col, Row } from 'reactstrap';
import displayDate from '../Helpers/displayDate';
import { HashimotoTestMeasurementFieldEnum, TestMeasurement } from '../types';
import TestsPopover from '../components/TestsPopover';

interface ITestsHistoryItem {
  testMeasurements: [string, TestMeasurement[]][];
  category?: HashimotoTestMeasurementFieldEnum;
  removeTest: any;
}

const TestsHistoryItem: React.FC<ITestsHistoryItem> = ({
  testMeasurements,
  category,
  removeTest,
}) => {
  const { t } = useTranslator();

  return (
    <div>
      {testMeasurements.length > 0 ? (
        testMeasurements.map((item, idx) => {
          return (
            <section key={idx}>
              <p className="medium mb-m">{item[0]}</p>
              <div className="white-box">
                {item[1].map((measurement, idx: number) => {
                  return (
                    <div key={idx}>
                      <Row className="align-items-center">
                        <Col>
                          <p className="description mb-0">{displayDate(measurement.testedAt)}</p>
                        </Col>
                        <Col className="text-end">
                          <p className="mb-0">
                            <span className="title-large semi-bold on-surface">
                              {measurement.value && measurement.value.toString().replace('.', ',')}
                            </span>{' '}
                            <span className="description">{t(`labTests.${category}.unit`)}</span>
                            <TestsPopover
                              removeMeasurement={removeTest}
                              measurement={{ ...measurement, type: category }}
                            />
                          </p>
                        </Col>
                      </Row>
                      {idx < item[1].length - 1 && <hr className="stroke-secondary-light" />}
                    </div>
                  );
                })}
              </div>
            </section>
          );
        })
      ) : (
        <section>
          <p className="description">{t('labTests.noMeasurements.subtitle')}</p>
        </section>
      )}
    </div>
  );
};

export default TestsHistoryItem;
